export const CORES_SITUACAO = {
    critico: { fundo: '#ffebee', texto: '#b71c1c', borda: '#ef9a9a' },
    atencao: { fundo: '#fff8e1', texto: '#8d6e00', borda: '#ffe082' },
    normal: { fundo: '#e8f5e9', texto: '#1b5e20', borda: '#a5d6a7' },
    neutro: { fundo: '#eceff1', texto: '#37474f', borda: '#cfd8dc' },
};

export const ROTULOS_ACAO = {
    antecipar_disponibilidade: 'Antecipar disponibilidade',
    avaliar_antecipacao_rolada: 'Antecipar ou reforçar rolada',
    planejar_nova_rolada: 'Planejar nova rolada',
    confirmar_liberacao_engomagem: 'Confirmar liberação da engomagem',
    definir_cronograma: 'Definir datas da rolada',
    manter_planejamento: 'Manter planejamento',
    revisar_data_rolada: 'Revisar ou postergar rolada',
};

export const PRIORIDADE_ACAO = {
    planejar_nova_rolada: 1,
    avaliar_antecipacao_rolada: 1,
    antecipar_disponibilidade: 1,
    confirmar_liberacao_engomagem: 2,
    definir_cronograma: 2,
    manter_planejamento: 3,
    revisar_data_rolada: 4,
};

export const ROTULOS_SETORES = {
    estoque: 'Estoque de peças',
    revisado: 'Revisado',
    revisao: 'Em revisão',
    acabado: 'Acabado',
    tecelagem: 'Saída da tecelagem',
    acabamento: 'Em acabamento',
    tear_estoque: 'Dentro dos teares',
};

export const ROTULOS_DEMANDAS = {
    pedidos: 'Pedidos de tecido',
    cortes: 'Ordens de corte',
    forros: 'Necessidade de forros',
};

export function formatarDataHora(valor) {
    if (!valor) {
        return '-';
    }

    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) {
        return '-';
    }

    return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(data);
}

export function formatarPrimeiroDeficit(valor) {
    if (!valor) {
        return '-';
    }

    const data = new Date(valor);

    if (Number.isNaN(data.getTime())) {
        return '-';
    }

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    if (data < hoje) {
        return 'Déficit já identificado';
    }

    return formatarDataHora(valor);
}

export function textoPrimeiroDeficit(valor) {
    const primeiroDeficit = formatarPrimeiroDeficit(valor);

    if (primeiroDeficit === '-') {
        return 'Sem data de déficit.';
    }

    if (primeiroDeficit === 'Déficit já identificado') {
        return 'Déficit já identificado.';
    }

    return `Primeiro déficit em ${primeiroDeficit}.`;
}

export function formatarNumero(valor) {
    return new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(valor || 0);
}

export function formatarCampoInteiro(rowData, props) {
    return formatarNumero(rowData[props.field]);
}

export function rotuloConfianca(confianca) {
    return {
        alta: 'Alta',
        media: 'Média',
        baixa: 'Baixa',
        sem_dados: 'Sem histórico',
    }[confianca] || 'Não informada';
}

export function rotuloRisco(risco) {
    return {
        critico: 'Crítico',
        atencao: 'Atenção',
        normal: 'Normal',
    }[risco] || 'Não informado';
}

export function formatarNumeroRolada(valor) {
    const digitos = String(valor || '').replace(/\D/g, '').slice(0, 5);

    if (digitos.length <= 2) {
        return digitos;
    }

    return `${digitos.slice(0, 2)}-${digitos.slice(2)}`;
}

export function criarLinhaRolada(rolada = {}) {
    return {
        chave: rolada.id ? `rolada-${rolada.id}` : `nova-${Date.now()}-${Math.random()}`,
        id: rolada.id || null,
        numero_rolada: formatarNumeroRolada(rolada.numero_rolada),
        cod_artigo: rolada.cod_artigo || '',
        metragem_total: rolada.metragem_total || '',
        data_inicio_planejada: rolada.data_inicio_planejada?.slice(0, 10) || '',
        data_disponibilidade_planejada: rolada.data_disponibilidade_planejada?.slice(0, 10) || '',
        ativo: rolada.ativo ?? true,
        alterada: false,
        salvando: false,
        salvaRecentemente: false,
        erro: '',
    };
}

export function calcularPrevisoesOperacionais(abastecimento) {
    return abastecimento.artigos.map((previsao) => {
        const conservador = previsao.cenario_conservador;
        const potencial = previsao.cenario_potencial;
        let situacao = 'normal';
        let situacaoLabel = 'Cobertura adequada';

        if (potencial.risco === 'critico') {
            situacao = 'critico';
            situacaoLabel = 'Falta mesmo com o plano';
        } else if (conservador.risco === 'critico') {
            situacao = 'atencao';
            situacaoLabel = 'Coberto pelo plano';
        } else if (potencial.risco === 'atencao' || conservador.risco === 'atencao') {
            situacao = 'atencao';
            situacaoLabel = 'Cobertura no limite';
        }

        return {
            ...previsao,
            situacao,
            situacaoLabel,
            demanda_horizonte: previsao.pcp.rolos_necessarios,
        };
    }).sort((primeiro, segundo) => {
        const ordem = { critico: 1, atencao: 2, normal: 3 };
        return ordem[primeiro.situacao] - ordem[segundo.situacao];
    });
}
